// extracted by mini-css-extract-plugin
export default {"gridCustomWidth":"CreationModal_gridCustomWidth__GUPII"};